export default __webpack_public_path__ + "media/images/features/toyono/ogp-72b82b9042a4d171b56c2244df1f40ae.jpg";